import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { URLBuilder2mz8zkz4u9ray as URLBuilder } from '../../../../../ktor-ktor-http/io/ktor/http/URLBuilder.mjs';
import { Companion_getInstance29j9s2wnmk34z as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import { HeadersBuilder3h7sn3kkvu98m as HeadersBuilder } from '../../../../../ktor-ktor-http/io/ktor/http/Headers.mjs';
import { EmptyContent_getInstance1v4yj3cymlz7 as EmptyContent_getInstance } from '../utils/Content.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { get_BodyTypeAttributeKey1jqpsdtzeru4e as get_BodyTypeAttributeKey } from './RequestBody.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { OutgoingContent3t2ohmyam9o76 as OutgoingContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { takeFromkqlcz7c6dx2r as takeFrom } from '../../../../../ktor-ktor-http/io/ktor/http/URLUtils.mjs';
import { appendAlltwnjnu28pmtx as appendAll } from '../../../../../ktor-ktor-utils/io/ktor/util/StringValues.mjs';
import {
  putAll10o0q8e6mgnzr as putAll,
  AttributeKey3aq8ytwgx54f7 as AttributeKey,
} from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { get_ENGINE_CAPABILITIES_KEYr1fjz8liznxo as get_ENGINE_CAPABILITIES_KEY } from '../engine/HttpClientEngineCapability.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { GMTDate36bhedawynxlf as GMTDate } from '../../../../../ktor-ktor-utils/io/ktor/util/date/DateJs.mjs';
import { ClientUpgradeContent299vg0lx1tyfp as ClientUpgradeContent } from './ClientUpgradeContent.mjs';
import { takeFrom3rd40szpqy350 as takeFrom_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLParser.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ResponseAdapterAttributeKey() {
  _init_properties_HttpRequest_kt__813lx1();
  return ResponseAdapterAttributeKey;
}
var ResponseAdapterAttributeKey;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
function HttpRequestBuilder$setCapability$lambda() {
  // Inline function 'kotlin.collections.mutableMapOf' call
  return LinkedHashMap().fc();
}
var HttpRequestBuilderClass;
function HttpRequestBuilder() {
  if (HttpRequestBuilderClass === VOID) {
    class $ {
      constructor() {
        this.h5l_1 = new (URLBuilder())();
        this.i5l_1 = Companion_getInstance().f55_1;
        this.j5l_1 = new (HeadersBuilder())();
        this.k5l_1 = EmptyContent_getInstance();
        this.l5l_1 = SupervisorJob();
        this.m5l_1 = AttributesJsFn(true);
      }
      e55() {
        return this.j5l_1;
      }
      a5p(value) {
        if (!(value == null)) {
          this.m5l_1.l4q(get_BodyTypeAttributeKey(), value);
        } else {
          this.m5l_1.n4q(get_BodyTypeAttributeKey());
        }
      }
      i5w() {
        return this.m5l_1.j4q(get_BodyTypeAttributeKey());
      }
      r5x(block) {
        return block(this.h5l_1, this.h5l_1);
      }
      e3a() {
        var tmp = this.h5l_1.e3a();
        var tmp_0 = this.i5l_1;
        var tmp_1 = this.j5l_1.e3a();
        var tmp_2 = this.k5l_1;
        var tmp0_elvis_lhs = tmp_2 instanceof OutgoingContent() ? tmp_2 : null;
        var tmp_3;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No request transformation found: ' + toString(this.k5l_1);
          throw IllegalStateException().o(toString(message));
        } else {
          tmp_3 = tmp0_elvis_lhs;
        }
        return new (HttpRequestData())(tmp, tmp_0, tmp_1, tmp_3, this.l5l_1, this.m5l_1);
      }
      z5o(builder) {
        this.l5l_1 = builder.l5l_1;
        return this.d5u(builder);
      }
      d5u(builder) {
        this.i5l_1 = builder.i5l_1;
        this.k5l_1 = builder.k5l_1;
        this.a5p(builder.i5w());
        takeFrom(this.h5l_1, builder.h5l_1);
        this.h5l_1.q58_1 = this.h5l_1.q58_1;
        appendAll(this.j5l_1, builder.j5l_1);
        putAll(this.m5l_1, builder.m5l_1);
        return this;
      }
      r5v(key, capability) {
        var tmp = get_ENGINE_CAPABILITIES_KEY();
        var capabilities = this.m5l_1.o4q(tmp, HttpRequestBuilder$setCapability$lambda);
        // Inline function 'kotlin.collections.set' call
        capabilities.b5(key, capability);
      }
      e5v(key) {
        var tmp0_safe_receiver = this.m5l_1.j4q(get_ENGINE_CAPABILITIES_KEY());
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v4(key);
      }
    }
    initMetadataForClass($, 'HttpRequestBuilder', HttpRequestBuilder);
    HttpRequestBuilderClass = $;
  }
  return HttpRequestBuilderClass;
}
function get_coroutineContext() {
  return this.f5m().ww();
}
var HttpRequestClass;
function HttpRequest() {
  if (HttpRequestClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'HttpRequest');
    HttpRequestClass = $;
  }
  return HttpRequestClass;
}
var HttpRequestDataClass;
function HttpRequestData() {
  if (HttpRequestDataClass === VOID) {
    class $ {
      constructor(url, method, headers, body, executionContext, attributes) {
        this.r5o_1 = url;
        this.s5o_1 = method;
        this.t5o_1 = headers;
        this.u5o_1 = body;
        this.v5o_1 = executionContext;
        this.w5o_1 = attributes;
        var tmp = this;
        var tmp0_safe_receiver = this.w5o_1.j4q(get_ENGINE_CAPABILITIES_KEY());
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w4();
        tmp.x5o_1 = tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
      }
      toString() {
        return 'HttpRequestData(url=' + this.r5o_1.toString() + ', method=' + this.s5o_1.toString() + ')';
      }
    }
    initMetadataForClass($, 'HttpRequestData');
    HttpRequestDataClass = $;
  }
  return HttpRequestDataClass;
}
var HttpResponseDataClass;
function HttpResponseData() {
  if (HttpResponseDataClass === VOID) {
    class $ {
      constructor(statusCode, requestTime, headers, version, body, callContext) {
        this.u5m_1 = statusCode;
        this.v5m_1 = requestTime;
        this.w5m_1 = headers;
        this.x5m_1 = version;
        this.y5m_1 = body;
        this.z5m_1 = callContext;
        this.a5n_1 = GMTDate();
      }
      toString() {
        return 'HttpResponseData=(statusCode=' + this.u5m_1.toString() + ')';
      }
    }
    initMetadataForClass($, 'HttpResponseData');
    HttpResponseDataClass = $;
  }
  return HttpResponseDataClass;
}
var ResponseAdapterClass;
function ResponseAdapter() {
  if (ResponseAdapterClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ResponseAdapter');
    ResponseAdapterClass = $;
  }
  return ResponseAdapterClass;
}
function isUpgradeRequest(_this__u8e3s4) {
  _init_properties_HttpRequest_kt__813lx1();
  var tmp = _this__u8e3s4.u5o_1;
  return tmp instanceof ClientUpgradeContent();
}
function headers(_this__u8e3s4, block) {
  _init_properties_HttpRequest_kt__813lx1();
  // Inline function 'kotlin.apply' call
  var this_0 = _this__u8e3s4.e55();
  block(this_0);
  return this_0;
}
function url(_this__u8e3s4, urlString) {
  _init_properties_HttpRequest_kt__813lx1();
  takeFrom_0(_this__u8e3s4.h5l_1, urlString);
}
var properties_initialized_HttpRequest_kt_zh09pz;
function _init_properties_HttpRequest_kt__813lx1() {
  if (!properties_initialized_HttpRequest_kt_zh09pz) {
    properties_initialized_HttpRequest_kt_zh09pz = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ResponseAdapterAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(ResponseAdapter());
    var tmp_0 = !(null == null) ? isInterface(null, ResponseAdapter()) : false;
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(getKClass(ResponseAdapter()), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp_0, tmp$ret$2);
    ResponseAdapterAttributeKey = new (AttributeKey())(name, tmp$ret$1);
  }
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  get_coroutineContext as get_coroutineContext1djaai1ellg0c,
  HttpRequestBuilder as HttpRequestBuilder15f2nnx9sjuv1,
  HttpRequest as HttpRequest3fsc4149kgwfg,
  HttpResponseData as HttpResponseData2dozo5khuplr6,
  get_ResponseAdapterAttributeKey as get_ResponseAdapterAttributeKey1ll13ywinsgvd,
  headers as headers24pki7ce1busg,
  isUpgradeRequest as isUpgradeRequest3msdo2i9hxs68,
  url as url2l6iw5ri21nxb,
};
//endregion

//# sourceMappingURL=HttpRequest.mjs.map
